import $ from 'jquery';
import { debounce } from '@github/mini-throttle';
const sum = function(nums) {
    return nums.reduce(function(acc, num) {
        return acc + num;
    }, 0);
};
/**
 * @description Collapse/expand main header menu
 */ export const init = async function() {
    const container = $('#js-header-menu');
    const list = container.find('.js-header-menu-list');
    const items = list.find('.js-header-menu-item');
    const toggle = container.find('.js-header-menu-toggle');
    const dropdown = container.find('.js-header-menu-toggle-dropdown');
    if (items.length === 0) {
        return;
    }
    const getVisibleCount = function(widths = [], containerWidth = 0, buttonWidth = 0) {
        if (sum(widths) < containerWidth) {
            return widths.length;
        }
        return widths.reduce(function(accumulator, width) {
            if (sum(accumulator) + width < containerWidth - buttonWidth) {
                accumulator.push(width);
            }
            return accumulator;
        }, []).length;
    };
    const itemWidths = items.map(function(_, element) {
        return $(element).outerWidth(true);
    }).get();
    const calcNav = function() {
        const visibleCount = getVisibleCount(itemWidths, container.outerWidth(true), toggle.outerWidth(true));
        dropdown.empty();
        toggle.toggleClass('is-hidden', visibleCount === items.length);
        items.each(function(index, element) {
            if (index + 1 > visibleCount) {
                $(element).addClass('is-collapsed').clone().appendTo(dropdown);
                return;
            }
            $(element).removeClass('is-collapsed');
        });
    };
    const debouncedCalcNav = debounce(calcNav, 100);
    $(window).on('resize', function() {
        debouncedCalcNav();
    });
    // Trim whitespace and comments between inline-block elements
    list.contents().filter(function(_, element) {
        return element.nodeType === 8;
    }).remove();
    list.contents().filter(function(_, element) {
        return element.nodeType === 3 && /\S/.test(element.nodeValue || '') === false;
    }).remove();
    calcNav();
    container.addClass('is-initialized');
};
